export default __webpack_public_path__ + "static/media/4_1.b5b80d02.jpg";